<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">BRANCH USERS</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout>
                        <v-list-tile @click="tableTitle='Active Users'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Active Branch Users</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="activeColor"><b>{{activeUsersCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="tableTitle='Invited Users'"> 
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Invited Branch Users</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="pendingColor"><b>{{pendingUsersCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="tableTitle='Disabled Users'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Inactive Branch Users</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="disabledColor"><b>{{disabledUsersCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <v-flex xs6 right>
                        <v-btn color="red accent-4" dark @click="goToPage('users-management/new')">ADD BRANCH USER</v-btn>
                    </v-flex>
                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                <v-flex xs12>
                    <v-data-table v-if="watchUsers=='activeUsers'" :search="search" :headers="headers" :items="activeUsers" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.email }}</td>
                            <td class="text-xs-left">{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.branchCode }}</td>
                            <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                            <td class="text-xs-left">{{ props.item.role }}</td>
                            <td class="text-xs-left">{{ props.item.activationDate }}</td>
                            <td class="text-xs-left">{{ props.item.modifiedDate }}</td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item)">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Active Users Available
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-data-table v-else-if="watchUsers=='pendingUsers'" :search="search" :headers="pendingHeaders" :items="pendingUsers" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.email }}</td>
                            <td class="text-xs-left">{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.branchCode }}</td>
                            <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                            <td class="text-xs-left">{{ props.item.role }}</td>
                            <td class="text-xs-left">{{ props.item.creationDate }}</td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Invited Users Available
                            </v-alert>
                        </template>
                         <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                     <v-data-table v-else-if="watchUsers=='disabledUsers'" :headers="inactiveHeaders" :search="search" :items="disabledUsers" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.email }}</td>
                            <td class="text-xs-left">{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.branchCode }}</td>
                             <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                            <td class="text-xs-left">{{ props.item.role }}</td>
                            <td class="text-xs-left">{{ props.item.inactiveDate }}</td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item)">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Disabled Users Available
                            </v-alert>
                        </template>
                         <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
                </v-container>
            </v-layout>

            <v-layout row justify-center >
                <v-dialog v-model="dialog" persistent width="300">
                    <v-card  color="primary">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" v-if="showProgress"
                                :size="70"
                                :width="5"
                                color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                 <v-snackbar v-model="snackbar" bottom right :color="snackbarColor">{{ snackbarMessage }} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>

                <v-dialog v-model="editDialog" persistent max-width="600px">
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="70">
                            <v-container>
                                <v-layout>
                                <h4 class="subheading font-weight-medium">UPDATE USER</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                        <v-layout wrap>
                            <v-container>
                            <v-flex xs12>
                                <v-text-field label="Email*" v-model='forChange.email' prepend-inner-icon="email" readonly></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-autocomplete v-model="forChange.branch"  label="Branch*" :items="activeBranches" persistent-hint prepend-inner-icon="domain" hide-no-data clearable leave-absolute>
                                    <template v-slot:append-outer>
                                        <v-slide-x-reverse-transition mode="out-in">
                                        </v-slide-x-reverse-transition>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 v-if="forChange.mobileNumber">
                                <v-text-field v-model="forChange.mobileNumber" :rules="mobileChecker" label="Mobile Number*" maxlength="10" prepend-inner-icon="phone" type="text" required hint=" ex.9123456789"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-select label="Role/ Position*" v-model='forChange.role' :items="roles" prepend-inner-icon="accessibility" required></v-select>
                            </v-flex>

                            <v-flex xs12>
                                <v-radio-group v-model="forChange.status" :mandatory="false" row>
                                    <v-radio label="Active" color="success" value="active"></v-radio>
                                    <v-radio label="Inactive" color="orange darken-4" value="disabled"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            </v-container>
                        </v-layout>
                        <v-layout justify-center>
                             <v-btn dark color="red accent-4" @click="editDialog=false">Cancel</v-btn>
                             <v-btn dark color="blue darken-4" @click="updateUser(forChange)">Save</v-btn>
                        </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
import Papa from "papaparse"
import { truncate, truncateSync } from 'fs'
export default {
    data() {
        return {
            tableTitle: "Active Users",
            headers: [
                { text: 'Email', align: 'left', sortable: false, value: 'email'},
                { text: 'Branch', value: 'branch',  sortable: false  },
                { text: 'Branch Code', value: 'branchCode',  sortable: false  },
                { text: 'Mobile Number', value: 'mobileNumber',  sortable: false  },
                { text: 'Role', value: 'role',  sortable: false  },
                { text: 'Activation Date', value: 'activationDate',  sortable: false },
                { text: 'Modified Date', value: 'modifiedDate',  sortable: false },
                { text: 'Actions', value: 'name', sortable: false }
            ],
            pendingHeaders: [
                { text: 'Email', align: 'left', sortable: false, value: 'email'},
                { text: 'Branch', value: 'branch',  sortable: false },
                { text: 'Branch Code', value: 'branchCode',  sortable: false  },
                { text: 'Mobile Number', value: 'mobileNumber',  sortable: false },
                { text: 'Role', value: 'role',  sortable: false },
                { text: 'Creation Date', value: 'creationDate',  sortable: false }
            ],
            inactiveHeaders: [
                { text: 'Email', align: 'left', sortable: false, value: 'email'},
                { text: 'Branch', value: 'branch',  sortable: false },
                { text: 'Branch Code', value: 'branchCode',  sortable: false  },
                { text: 'Mobile Number', value: 'mobileNumber',  sortable: false },
                { text: 'Role', value: 'role',  sortable: false },
                { text: 'Inactive Date', value: 'inactiveDate',  sortable: false },
                { text: 'Actions', value: 'name', sortable: false }
            ],
            watchUsers: "activeUsers",
            users: [],
            activeUsers: [],
            activeUsersCount: 0,
            pendingUsers: [],
            pendingUsersCount: 0,
            disabledUsers: [],
            disabledUsersCount: 0,
            showUsers: false,
            filename: "",
            uploadBtn: true,
            search: "",
            file: null,
            snackbar: false,
            snackbarColor: "",
            snackbarMessage: "",
            progressMessage: "",
            showProgress: false,
            dialog: false,
            activeColor: "red",
            pendingColor: "grey",
            disabledColor: "grey",
            editDialog: false,
            userStatus: "",
            forChange: {},
            branches: [],
            activeBranches: [],
            mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
            roles: [],
            roleItems: [],
            branchId: "",
        }
    },

    methods: {
        async fetchRoles() {
            let self = this
            self.roles = []

            await db.collection("Settings"+self.$stage).doc("Roles")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.roleItems.push(doc.data())
                })
            }).then(function() {
                self.roleItems.forEach(function(res) {
                    self.roles.push(res.role)
                })
            }).catch(function(error){
                console.log(error)
            })
        },

        
        async fetchBranches() {
            let self = this 
            self.activeBranches = []
            self.branches = []
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        if (doc.data().status == true) {
                            self.activeBranches.push(`${doc.data().branchCode}_${doc.data().businessUnit}`)
                            self.branches.push(doc.data())
                        }
                    })
                }).then(function(){
                    if (self.activeBranches.length == 0) {
                        self.snackbarMessage = "Please setup Branch"
                        self.snackbarColor = "error"
                        self.snackbar = true
                    } else {
                        self.activeBranches = _.sortBy(self.activeBranches, o => o.cluster)
                    }
                }).catch(function(error) {
                    console.error("Error fetching document: ", error)
                    self.snackbarMessage = "Error fetching data" 
                    self.snackbarColor = "error"
                    self.snackbar= true
                })
        },

        notification(email){
            let self = this

            let message = "Hello!" + "\n\n Admin".bold() + " set up your account in Service Scheduler. \n\n Service Scheduler is a scheduling tool that helps the customers set up service appointment accross different branches at their most convenient day and time. \n\n " + "Your Login Email: ".bold() + email + "\n\nPlese click on the button below or " +"click this link".link(self.$branchUrl + "/login")  + " to confirm your email address and access the site.\n\n " +  '<form action="branch.aftersales.scinnova.com.ph/login"><button type="submit"><b>Confirm My Email</b></button></form>'+"\n\n Sincerely,\nService Scheduler Team"

            let emailMessage = message.replace(/(\r\n|\n|\r)/gm, "<br>")
        
            let load = {
                "receiver" : email,
                "subject" : "Admin has set up your account on Service Scheduler",
                "html" : emailMessage
            }

            self.$axios.post(self.$mailerUrl, load).then(response => {

            }).catch(function(error) {
                console.error(error)
            })
        },
        
        goToPage(page) {
            this.$router.push("/"+page)
        },

        async fetchUsers () {
            let self = this

            await db.collection("branchUsers"+self.$stage).onSnapshot(function(querySnapshot) {
                self.users = []
                self.activeUsers= []
                self.pendingUsers= []
                self.disabledUsers= []
                self.dialog = true
                self.progressMessage = "Loading Users"
                self.showProgress = true

                querySnapshot.forEach(function(doc) {
                    self.users.push(doc.data())
                    if(doc.data().status == "active") {
                        self.activeUsers.push(doc.data())
                    } else if(doc.data().status == "pending") {
                        self.pendingUsers.push(doc.data())
                    } else  if(doc.data().status == "disabled") {
                        self.disabledUsers.push(doc.data())
                    }
                })

                setTimeout(() => {
                    self.dialog = false
                    self.showProgress = false
                    self.activeUsersCount = self.activeUsers.length
                    self.pendingUsersCount = self.pendingUsers.length
                    self.disabledUsersCount = self.disabledUsers.length
                }, 500);
            })
        },

        requestForChange(user) {
            let self = this 
            db.collection("branchUsers"+self.$stage).doc(user.email)
            .get().then(function(doc) {
                self.forChange = {
                    email: doc.data().email,
                    branch: `${doc.data().branchCode}_${doc.data().branch}`,
                    branchCode: "",
                    branchId: self.branchId,
                    mobileNumber: doc.data().mobileNumber,
                    role: doc.data().role,
                    status: doc.data().status,
                    creationDate: doc.data().creationDate,
                    activationDate: doc.data().activationDate,
                    modifiedDate: doc.data().modifiedDate,
                    inactiveDate: doc.data().inactiveDate
                }
            }).then(function() {
                self.editDialog = true
            })
        },

        updateUser(user) {
            let self = this
            if (user.mobileNumber.length === 10) {
                self.dialog = true
                self.showProgress = true
                self.progressMessage = "Updating branch user"
                if(user.status === "disabled") {
                    db.collection("branchUsers"+self.$stage).doc(user.email)
                    .update({
                        branch: user.branch.split('_')[1].trim(),
                        branchCode: user.branch.split('_')[0].trim(),
                        branchId: self.branchId,
                        mobileNumber: user.mobileNumber,
                        role: user.role,
                        status: user.status,
                        inactiveDate: moment().format('MMMM Do YYYY, h:mm:ss a')
                    }).then(function() {
                        closed()
                    })
                } else {
                    db.collection("branchUsers"+self.$stage).doc(user.email)
                    .update({
                        branch: user.branch.split('_')[1].trim(),
                        branchCode: user.branch.split('_')[0].trim(),
                        branchId: self.branchId,
                        mobileNumber: user.mobileNumber,
                        role: user.role,
                        status: user.status,
                        modifiedDate: moment().format('MMMM Do YYYY, h:mm:ss a')
                    }).then(function() {
                        closed()
                    })
                }
            } else {
                self.snackbarMessage = "Please input valid mobile number"
                self.snackbarColor = "error"
                self.snackbar = true
            }    

            function closed() {
                setTimeout(() => {
                    self.dialog = false
                    self.showProgress = false
                    self.snackbarColor = "success"
                    self.snackbarMessage = "Branch User Updated"
                    self.snackbar = true
                    self.editDialog = false
                    self.fetchUsers()
                }, 500)
            }
        },
    },

    computed : {
        ...mapGetters(["user"]),
    },

    watch: {
        tableTitle(val) {
            if(this.tableTitle == "Active Users"){
                this.activeColor = "red"
                this.pendingColor = "grey"
                this.disabledColor = "grey"
                this.watchUsers = "activeUsers"
            } else if(this.tableTitle == "Invited Users"){
                this.pendingColor = "red"
                this.activeColor = "grey"
                this.disabledColor = "grey"
                this.watchUsers = "pendingUsers"
            } else if(this.tableTitle == "Disabled Users"){
                this.disabledColor = "red"
                this.pendingColor = "grey"
                this.activeColor = "grey"
                this.watchUsers = "disabledUsers"
            }
        },
        
        forChange: {
            handler: function(val) {
                let self = this
                self.branchId = ""
                _.find(self.branches, function(o) {
                    if (o.branchCode == val.branch.split('_')[0].trim()) {
                        self.branchId = o.id
                    }
                })
            },
            deep: true
        }
    },

    mounted () {
        this.fetchBranches()
        this.fetchUsers()
        this.fetchRoles()
    }
}
</script>

<style scoped>

</style>




